import { DataSender } from '../loaders'
/**
 * Achievements overlay
 */
class AchievementsOverlay {
	constructor(list) {
        this._list = null;
        this._length = 0;

        this._overlay = null;
        this._close = null;
        this._wrapper = null;
        this._greeting = null;
        this._intro = null;
        this._heading = null;
        this._description = null;
        this._navigation = null;
        this._actions = null;

        this._index = 0;
        this._current = null;
        this._images = null;
        this._buttons = null;

    	this._list = list;
    	this._length = list.length;

        this.initLayout();
    }

    initLayout() {
    	this._overlay = $('div.achievements-overlay');
        this._close = $('a.close', this._overlay);
    	this._wrapper = $('div.wrapper', this._overlay);
    	this._greeting = $('span.greeting', this._overlay);
    	this._intro = $('span.intro', this._overlay);
    	this._heading = $('h1', this._overlay);
    	this._description = $('span.description', this._overlay);
    	this._navigation = $('nav', this._overlay);
    	this._actions = $('div.actions', this._overlay);

        var that = this;

        $(this._close).on('click',function(e){ that.closeClickHandler(that); });

    	if(this._length > 1) {
    		this._wrapper.addClass('multiple');
    	}

    	for(var i = 0; i < this._length; i++) {
    		this._wrapper.append('<div class="image"><a href="#" style="background-image: url(/img/web/achievements/' + this._list[i].key + '-icon.png);"></a></div>');
    		this._navigation.append('<a href="#"></a>');
    	}

    	this._images = $('div.image', this._wrapper);
		this._images.each(function(i) { $(this).click({ index: i }, this.itemClickHandler); });
		this._buttons = $('a', this._navigation);
		this._buttons.each(function(i) { $(this).click({ index: i }, this.itemClickHandler); });

		this.showAchievement();

    	// animations
    	window.setTimeout(function() {
    		that._overlay.css({ opacity: 1.0 });
    	}, 250);

    	window.setTimeout(function() {
    		that._greeting.addClass('transition').css({ top: 0, opacity: 1.0 });
    	}, 500);

    	window.setTimeout(function() {
    		that._intro.addClass('transition').css({ top: 25, opacity: 1.0 });
    	}, 750);

    	window.setTimeout(function() {
    		that._heading.addClass('transition').css({ top: 228, opacity: 1.0 });
    	}, 1000);

    	window.setTimeout(function() {
    		that._description.addClass('transition').css({ top: 266, opacity: 1.0 });
    	}, 1250);

    	window.setTimeout(function() {
    		that._navigation.addClass('transition').css({ opacity: 1.0 });
    	}, 1500);

    	window.setTimeout(function() {
    		$('span, h1, nav', that._wrapper).removeClass('transition');
    		that.showAchievement(0);
    	}, 1750);

    	window.setTimeout(function() {
    		that._actions.css({ bottom: 0 });
    	}, 2000);

        // keyboard shortcuts
        $(document).bind('keydown', this.keyDownHandler);

    	// stop page scrolling
    	window.evedo.disablePageScrolling();
    }

    closeClickHandler(e) {
        e.close();
        return false;
    }

    itemClickHandler(e) {
    	e.data.target.showAchievement(e.data.index);
    	return false;
    }

    keyDownHandler(e) {
        var that = e.data.target;

        switch(e.which) {
            case 37:
                if(that._index > 0) that.showAchievement(that._index - 1);
                break;

            case 39:
                if(that._index < that._length - 1) that.showAchievement(that._index + 1);
                break;

            case 27:
                that.close();
                break;
        }
    }

    showAchievement(index) {
        this._current = this._list[index];
        this.index = index;
    	var first = false;
    	var that = this;

    	if(index == undefined) {
    		first = true;
    		index = 0;
    	}
        else {
            this._index = index;
        }

    	this._images.each(function(i) {
    		if(i == index) {
    			that._buttons.eq(i).addClass('active');
    			if(!first) that._images.eq(i).removeClass('inactive').addClass('active');
    			that._images.eq(i).css('left', 250);
    		}
    		else {
    			that._buttons.eq(i).removeClass('active');
    			if(!first) that._images.eq(i).removeClass('active').addClass('inactive');
    			that._images.eq(i).css('left', (i > index ? 270 + (i - index) * 150 : 230 - (index - i) * 150));
    		}
    	});

    	this._heading.text(this._list[index].name);
    	this._description.text(this._list[index].description);
    }

    close() {
        var that = this;
        new DataSender({
            data: {
                id: this._current.id
            },
            url: '/profile/achievements/dismiss',

            success: function(data) {
                if(data.status) {

                }
            },
            error: function(e){
                console.log(e);
            }
        });


        // animations
        window.setTimeout(function() {
            that._wrapper.addClass('transition');
            that._wrapper.css({ top: '55%', opacity: 0 });
        }, 250);

        window.setTimeout(function() {
            that._overlay.css({ opacity: 0 });
        }, 500);

        window.setTimeout(function() {
            that._overlay.remove();
        }, 800);

        // keyboard shortcuts
        $(document).unbind('keydown', this.keyDownHandler);

        // enable page scrolling
        window.evedo.enablePageScrolling();
    }
}

export { AchievementsOverlay };
